import * as types from "./mutation_types";

export default {
  [types.ASSISE_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.ASSISE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.ASSISE_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.ASSISE_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
